export enum ICustomerVenueWizardStepsEnum {
  Step1 = "details",
  Step2 = "nfcTagDetails",
  Step3 = "customerFloorNfcTagsState",
}
